export default __webpack_public_path__ + "static/media/level-complete-image2.0d8f03ba.png";